 
  <mat-card class="dashboard-card">
    <mat-card-header>
      <mat-card-title> About </mat-card-title>
    </mat-card-header>
    <mat-card-content class="dashboard-card-content">
      <section
        class="h-100 mat-typography"
        fxLayout
        fxLayoutAlign="center center"
      >
        <div class="text-centered">
          <h1>404</h1>
          <h2>Sorry, this page does not exist.</h2>
          <p>
            Please check the spelling in your address bar or try a different
            URL.
          </p>
          <a mat-stroked-button color="accent" routerLink="/">Home</a>
        </div>
      </section>
    </mat-card-content>
  </mat-card> 
